import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import DropList from './DropList'; // import * as portalClient from 'utils/portalClient'

import { connect } from 'react-redux';
import { getAiProcessorList } from '../../../api/deviceAPI';
var t = i18n.getFixedT(null, 'setting-device');

var DynamicRadio = /*#__PURE__*/function (_Component) {
  _inherits(DynamicRadio, _Component);

  var _super = _createSuper(DynamicRadio);

  function DynamicRadio(props) {
    var _this;

    _classCallCheck(this, DynamicRadio);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getOptionName", function (name) {
      var _key = "parameter_list.".concat(name);

      var _name = t(_key);

      if (_key == _name) {
        _name = name;
      }

      return _name;
    });

    _defineProperty(_assertThisInitialized(_this), "buildDynamicOptions", function (availOptions) {
      var param = _this.props.param;
      var _items = [];

      var interOptions = _.get(param, 'intersection[0].option', []); //console.log('hl intersection: ', interOptions)


      if (interOptions.length > 0) {
        var minValue = Infinity;
        var minId = "";
        interOptions.map(function (op, index) {
          var find = availOptions.find(function (el) {
            return el.id == op.attr.id;
          });

          if (find) {
            _items.push({
              value: op.attr.id,
              text: _this.getOptionName(op.attr.name),
              name: op.attr.name,
              order: op.attr.order,
              default: "0"
            });

            if (parseInt(op.attr.default_priority) < minValue) {
              minValue = parseInt(op.attr.default_priority);
              minId = op.attr.id;
            }
          }
        });
        _items.find(function (it) {
          return it.value === minId;
        }).default = "1";
      }

      return _items;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeSelected", function (e) {
      var _this$state = _this.state,
          items = _this$state.items,
          selectedIdx = _this$state.selectedIdx;
      var _selectedIdx = selectedIdx;
      var _option = []; // console.log('hl e: ', e)

      if (items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          var el = items[i];
          var _value = "0";

          if (el.value == e) {
            _value = "1";
            _selectedIdx = i;
          }

          _option.push({
            $: {
              id: el.value,
              name: el.name,
              order: el.order,
              default: el.default
            },
            _: _value
          });
        }
      }

      if (_this.props.onChangeSelected) {
        _this.props.onChangeSelected(_option);
      }

      _this.setState({
        value: e,
        selectedIdx: _selectedIdx
      });
    });

    _this.state = {
      value: undefined,
      selectedIdx: 0,
      availableOptions: [],
      disableOptions: [],
      items: []
    };
    return _this;
  }

  _createClass(DynamicRadio, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var _this$props = this.props,
          param = _this$props.param,
          contextRoot = _this$props.contextRoot,
          nvrIp = _this$props.nvrIp; // console.log('hl dynamic radio param: ', param)

      var url = _.get(param, 'attr.src', null);

      var realXmlObj = _.get(param, 'realXmlObj', {});

      var _url = url.replace('{', '');

      _url = _url.replace('}', '');

      if (url) {
        var _availOptions = []; // portalClient.getDynamicRadioOptions(_url, realXmlObj).then(r => {

        getAiProcessorList(contextRoot, false, nvrIp).then(function (r) {
          try {
            console.log('ad availability', r);
            var _avail = r.content;

            if (_avail && _avail.length > 0) {
              for (var i = 0; i < _avail.length; i++) {
                var el = _avail[i];

                _availOptions.push({
                  id: el,
                  name: "str_".concat(el),
                  order: i.toString(),
                  default: "0"
                });
              }
            }
          } catch (error) {
            console.error('Parsing dynamic radio options fail', error);
          }
        }).catch(function (e) {
          console.error('getDynamicRadioOptions fail', e);
        }).then(function () {
          var _disableOptions = [],
              _items = [];
          var _value = undefined,
              _selectedIdx = 0;

          var _savedOptions = _.get(param, 'options[0].option', []);

          var _savedOption = undefined;

          _savedOptions.map(function (el) {
            if (el.value == "1") {
              _savedOption = el;
            }
          }); // console.log('hl items: ', _items)


          _items = _this2.buildDynamicOptions(_availOptions);

          _items.map(function (el, index) {
            if (el.default == "1") {
              _value = el.value;
              _selectedIdx = index;
            }
          });

          if (_savedOption) {
            var find = _items.find(function (el) {
              return el.value == _savedOption.attr.id;
            });

            if (find) {
              _items.map(function (el, index) {
                // set the saved value instead of the default value
                if (el.value == _savedOption.attr.id) {
                  _value = _savedOption.attr.id;
                  _selectedIdx = index;
                }
              });
            } else {
              // create this option and then disable it
              var newItemIdx = _items.push({
                value: _savedOption.attr.id,
                text: _this2.getOptionName(_savedOption.attr.name),
                name: _savedOption.attr.name,
                order: _savedOption.attr.order,
                default: _savedOption.attr.default
              });

              _value = _savedOption.attr.id;
              _selectedIdx = newItemIdx;

              _disableOptions.push(_value);
            }
          } else {
            // if no saved option, change this condition's profile structure by the default option
            var _option = [];

            _items.forEach(function (el, index) {
              var v = el.default == "1" ? "1" : "0";

              _option.push({
                $: {
                  id: el.value,
                  name: el.name,
                  order: el.order,
                  default: el.default
                },
                _: v
              });
            });

            if (_this2.props.onChangeSelected) {
              _this2.props.onChangeSelected(_option);
            }
          }

          _this2.setState({
            availableOptions: _availOptions,
            items: _items,
            value: _value,
            selectedIdx: _selectedIdx,
            disableOptions: _disableOptions
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          value = _this$state2.value,
          selectedIdx = _this$state2.selectedIdx,
          items = _this$state2.items,
          disableOptions = _this$state2.disableOptions;
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-item-wrapper arrow"
      }, /*#__PURE__*/React.createElement(DropList, {
        disableOptions: disableOptions,
        selected: value,
        scrollToIndex: selectedIdx,
        list: items,
        onChangeSelected: this.handleChangeSelected
      }));
    }
  }]);

  return DynamicRadio;
}(Component);

DynamicRadio.propTypes = {
  param: PropTypes.object,
  onChangeSelected: PropTypes.func
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$toJS = state.toJS(),
      envCfg = _state$toJS.envCfg,
      device = _state$toJS.device;

  return {
    contextRoot: envCfg.contextRoot,
    nvrIp: device.nvrIp
  };
};

export default connect(mapStateToProps)(DynamicRadio);